import React from 'react';
import { Section } from '@atlaskit/side-navigation';
import { ForgeScreenEvent } from '@atlassian/jira-forge-ui-analytics/src/common/ui/index.tsx';
import { TriggerAnalyticsWrapper } from '@atlassian/jira-forge-ui-analytics/src/ui/personal-settings-page/index.tsx';
import { PERSONAL_SETTINGS_PAGE_MODULE } from '@atlassian/jira-forge-ui-constants/src/constants.tsx';
import type { PersonalSettingsPage } from '@atlassian/jira-forge-ui-types/src/common/types/extension.tsx';
import { parseExtensionId } from '@atlassian/jira-forge-ui-utils-internal/src/utils/parse-extension-id/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { getAppsPersonalSettingsPath } from '@atlassian/jira-personal-settings-paths/src/index.tsx';
import { ForgeItem } from '../../common/ui/forge-item/index.tsx';
import { toSections } from '../../common/utils/subpages/index.tsx';
import { usePersonalSettingsForgeApps } from '../../controllers/personal-settings/index.tsx';
import { messages } from './messages.tsx';

export const getItemHref = (extension: PersonalSettingsPage) => {
	const { appId, envId } = parseExtensionId(extension.id);
	return `${getAppsPersonalSettingsPath()}/${appId}/${envId}`;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const BaseForgePersonalSettingsSection: Flow.AbstractComponent<Record<any, any>> = () => {
	const { formatMessage } = useIntl();
	const { data: pages } = usePersonalSettingsForgeApps();

	if (!pages?.length) return null;

	return (
		<Section title={formatMessage(messages.forgeSectionTitle)}>
			{pages.map((extension) => (
				<ForgeItem
					key={extension.id}
					id={extension.id}
					environmentType={extension.environmentType}
					environmentKey={extension.environmentKey}
					url={getItemHref(extension)}
					name={extension.properties.title}
					sections={toSections(extension)}
					moduleName={PERSONAL_SETTINGS_PAGE_MODULE}
					iconUrl={extension.properties.icon}
					showIcon
				/>
			))}
			<ForgeScreenEvent
				attributes={{
					moduleType: PERSONAL_SETTINGS_PAGE_MODULE,
				}}
			/>
		</Section>
	);
};
export const ForgePersonalSettingsSection = (): React.JSX.Element => (
	<TriggerAnalyticsWrapper>
		<BaseForgePersonalSettingsSection />
	</TriggerAnalyticsWrapper>
);
